import { render } from "./SalesOrderModal.vue?vue&type=template&id=a24df208&ts=true"
import script from "./SalesOrderModal.vue?vue&type=script&lang=ts"
export * from "./SalesOrderModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__